export default "__VITE_ASSET__e1f76791__"